import { render, staticRenderFns } from "./InfoDetails.vue?vue&type=template&id=3eccee8d&scoped=true"
import script from "./InfoDetails.vue?vue&type=script&lang=js"
export * from "./InfoDetails.vue?vue&type=script&lang=js"
import style0 from "./InfoDetails.vue?vue&type=style&index=0&id=3eccee8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eccee8d",
  null
  
)

export default component.exports